import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsfEnum } from "@/utils/indicatorsEsf";
import { ResumeIndicatorC2Data } from "@/services/esus/indicator/esf/c2/getResumeIndicatorC2";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsfC2ResumeProps = {
	resume: ResumeIndicatorC2Data;
};

export function IndicatorEsfC2Resume({ resume }: Readonly<IndicatorEsfC2ResumeProps>) {
	const citizensWithTwoYearsInQuarterIndicatorPercentage = calculatePercentage(
		resume.totalCitizensWithTwoYearsInPeriodScore,
		resume.maxCitizensWithTwoYearsInPeriodScore
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Crianças com até 2 anos no período"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={resume.totalCitizens.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header="Crianças com até 2 anos no período"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de crianças com até 2 anos de idade no período
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Crianças com 2 anos completos no período"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={resume.totalCitizensWithTwoYearsInPeriod.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header="Crianças com 2 anos completos no período"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de crianças com 2 anos completos no período
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Pontuação"
					value={resume.totalCitizensWithTwoYearsInPeriodScore.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Pontuação"
							message="Quantidade de pontos alcançados nas práticas realizadas no indicador(somatório de pontos de todos os cidadãos)"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="% Classificação"
					value={`${citizensWithTwoYearsInQuarterIndicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsfEnum.C2,
						citizensWithTwoYearsInQuarterIndicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="% Classificação"
							message="Percentual de pontos alcançados no acompanhamento de crianças com 2 anos completos em relação a pontuação máxima do indicador"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
		</Row>
	);
}
